import {ScrollTrigger} from "../LibrariesImport";

export default class NavLang {
    static init() {
        const trigger = document.querySelector(".nav-lang");
        if (trigger) {
            this.initNavLang(trigger);
        }
    }

    static initNavLang(trigger) {
        if (ScrollTrigger.isTouch === 1) {
            document.addEventListener('click', (e) => {
                const withinBoundaries = e.composedPath().includes(trigger);

                if (withinBoundaries) {
                    trigger.classList.add('nav-lang-opened');
                } else {
                    trigger.classList.remove('nav-lang-opened');
                }
            });
        } else {
            trigger.addEventListener('mouseenter', (e) => {
                trigger.classList.add('nav-lang-opened');
            });

            trigger.addEventListener('mouseleave', (e) => {
                trigger.classList.remove('nav-lang-opened');
            });
        }
    }
}